import UrlUtil from '../util/urlUtil.js';

// const devServiceUrl = 'http://localhost:20065';
const devServiceUrl = 'http://112.4.186.22:9081';
//const prodServiceUrl = 'https://ssl.springland.com.cn';


const devClientUrl = 'http://127.0.0.1:8080';
//const prodClientUrl = 'https://ssl.springland.com.cn/smp-client';

const prodClientDir = 'smp-client';

const urlUtil = new UrlUtil(devServiceUrl,devClientUrl,prodClientDir);

export default {

  
  //gatewayUrl : process.env.NODE_ENV=='development' ? devServiceUrl : prodServiceUrl,
  gatewayUrl : urlUtil.getGatewayUrl(),
  authServicePath : '/auth-service',
  smpServicePath : '/smp-service',
  pdServicePath : '/pd-service' ,
  smMarketManageServicePath : '/sm-market-manage-service',
  machineServicePath: '/goods-sale-machine-service',
  appointmentServicePath: '/appointment-service',
  freshOrdersPath: '/sm-mid-platform-service',
  alarmOrdersPath: '/target-warning-service',
  printCouponServicePath: '/print-coupon-service',
  masterDataServicePath: '/master-data-service',
  ncAdapterServicePath: '/nc-adapter',

  //clientUrl: process.env.NODE_ENV == 'development' ? devClientUrl : prodClientUrl,
  clientUrl : urlUtil.getClientUrl(),
  clientMainPath: '/main',

}  

